
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function BlogPage() {
  const blogPosts = [
    {
      title: 'Why So Many Skilled Tradesmen Are Trapped in Their Own Business',
      excerpt: 'Discover the hidden challenges that keep talented HVAC professionals stuck working in their business instead of on it, and learn the proven strategies to break free.',
      date: 'January 15, 2025',
      readTime: '8 min read',
      link: 'https://www.openpr.com/news/4337911/why-so-many-skilled-tradesmen-are-trapped-in-their-own',
      category: 'Business Growth',
      image: 'https://public.readdy.ai/ai/img_res/3749295455f97988690d27460f937900.jpg'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-[#0F3A2E] to-[#0A2A20]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#C9A24D] rounded-2xl mb-6 shadow-2xl">
            <i className="ri-article-line text-4xl text-[#0F3A2E]"></i>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
            Insights & Resources
          </h1>
          <p className="text-lg text-white/90 max-w-3xl mx-auto">
            Expert guidance and proven strategies to help you grow your business with purpose and integrity.
          </p>
        </div>
      </section>

      {/* Blog Posts Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post, index) => (
              <article
                key={index}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow group"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="px-4 py-2 bg-[#C9A24D] text-white text-sm font-semibold rounded-full">
                      {post.category}
                    </span>
                  </div>
                </div>

                <div className="p-8">
                  <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {post.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {post.readTime}
                    </span>
                  </div>

                  <h2 className="text-2xl font-bold text-[#0F3A2E] mb-4 group-hover:text-[#C9A24D] transition-colors" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {post.title}
                  </h2>

                  <p className="text-base text-gray-700 leading-relaxed mb-6">
                    {post.excerpt}
                  </p>

                  <a
                    href={post.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-[#C9A24D] font-semibold hover:text-[#B8963E] transition-colors cursor-pointer"
                  >
                    Read Full Article
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </article>
            ))}
          </div>

          {/* Coming Soon Message */}
          <div className="mt-16 text-center bg-white rounded-2xl p-12 shadow-lg">
            <div className="w-16 h-16 bg-[#C9A24D]/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-quill-pen-line text-3xl text-[#C9A24D]"></i>
            </div>
            <h3 className="text-3xl font-bold text-[#0F3A2E] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              More Insights Coming Soon
            </h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We're constantly creating valuable content to help you grow your business. Check back regularly for new articles, case studies, and expert insights.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
